import * as React from "react";
import Box from "@mui/material/Box";
import Grid from '@mui/material/Grid';
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import DensityMediumIcon from "@mui/icons-material/DensityMedium";
import CloseIcon from "@mui/icons-material/Close";
import HomeIcon from "@mui/icons-material/Home";
import PersonIcon from "@mui/icons-material/Person";
import MedicationIcon from "@mui/icons-material/Medication";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import LogoutIcon from "@mui/icons-material/Logout";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import SpeedIcon from '@mui/icons-material/Speed';
import LanguageIcon from '@mui/icons-material/Language';
import FeedbackIcon from '@mui/icons-material/Feedback';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import SummarizeIcon from '@mui/icons-material/Summarize';
import TimelineIcon from '@mui/icons-material/Timeline';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import AutoDeleteIcon from '@mui/icons-material/AutoDelete';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useNavigate } from "react-router";
import { Typography } from "@mui/material";
import imgurl from "../assests/images/imgurl";
import Link from "@mui/material/Link";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LanguageSelector from "../LanguageSelector";
import HtmlContentMaster from "../utils/HtmlContentMaster";
import i18next from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { postApi } from "../api/services";
import { setfrontview, setleftview, setrightview, settopview } from "../Reducers/reducer";
import { clearImagesInRedux, gTagTracking, serviceDown, trackEvent } from "../utils/UtilityFunctions";
import { useLocation } from 'react-router-dom';

function Sidebar({from}) {
  const dispatch = useDispatch();
  const location = useLocation()
  const [open, setOpen] = React.useState(false);
  const [fname,setfname] = React.useState('')
  const [lname,setlname] = React.useState('')
  const [privacyDrawer, setPrivacyDrawer] = React.useState(false)
  const [termsDrawer, setTermsDrawer] = React.useState(false)
  const [isMobile, setIsMobile] = React.useState(false);
  let checkUserData = JSON.parse(sessionStorage.getItem("checkUser"));

  const navigate = useNavigate();

  const locale = useSelector((state) => state.language.langData)
  
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  React.useEffect(() => {
    if (!window.cordova) {
      let isMobile = /iPhone|iPod|iPad|Android/i.test(navigator.userAgent);
      if (!isMobile) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    }
  }, [isMobile]);
 
  React.useEffect(()=>{
    setTimeout(() => {
      
      console.log(localStorage.getItem('fname'),localStorage.getItem('lname'));
      
      setfname(localStorage.getItem('fname'))
      setlname( localStorage.getItem('lname'))
    }, 1000);
  },[])

  const toDo = async (what) => {
    const val = await swal({
      title: what == 'logout' ? i18next.t('Are you sure you want to logout?') : what == 'deleteAccount' ? i18next.t('Your user profile and all of your data will be deleted within 30 days.') : '',
      text: what == 'deleteAccount' ? i18next.t('Please confirm') : '',
      buttons: {
        confirm: {
          text: i18next.t("Yes"),
          value: true,
          visible: true,
        },
        cancel: {
          text: i18next.t("No"),
          value: false,
          visible: true,
        },
      },
      className: "multiple-button-swal",
    })

    if(val && what == 'logout'){
      await trackEvent('user_logged_out', 'success', " ", localStorage.getItem('phno'))
      await gTagTracking('user_logged_out', {
        action: 'success',
        error: " ",
        mobile_number: localStorage.getItem('phno')
      })
      localStorage.clear();
      sessionStorage.clear();
      clearImagesInRedux(dispatch)
      window.cordova ? navigate('/Onboarding') : navigate('/loginpage')
    } else if(val && what == 'deleteAccount'){
      deleteAccount()
    }
  }

  const deleteAccount = async () => {
    let params = {
      user_id: localStorage.getItem('user_id')
    }
    try {
      const res = await postApi('delete_user', params)
      if(res){
        await trackEvent('account_deleted', 'success', " ", localStorage.getItem('phno'))
        await gTagTracking('account_deleted', {
          action: 'success',
          error: " ",
          mobile_number: localStorage.getItem('phno')
        })
        localStorage.clear();
        sessionStorage.clear();
        clearImagesInRedux(dispatch)
        window.cordova ? navigate('/Onboarding') : navigate('/loginpage')
      }
    } catch (err) {
      console.log("err", err); 
      await trackEvent('account_deleted', 'fail', err, localStorage.getItem('phno'))  
      await gTagTracking('account_deleted', {
        action: 'fail',
        error: err,
        mobile_number: localStorage.getItem('phno')
      })
      serviceDown()     
    }
  }

  const handleFeedback = () =>{
    navigate('/feedback', {state: {from: "sidebar"}})
  }

  const proceedToNxt = () => {
    
    let encrypted = encryptPhoneNum(localStorage.getItem('phno'))
    let url = `https://aloxa.ai/feedback?phno=${encrypted}&lang=${locale}`;
    window.open(url, "_blank");
    
  }
  
  const encryptPhoneNum = (phone) => {
    return btoa(encodeURIComponent(phone))
  }

  const handleUrl = (which, to) => {
    let url 
    if(which === "home"){
      url = "https://alopexia.com/"
    } else if(which === "about"){
      url = "https://alopexia.com/about-alopexia"
    } else if(which === "men"){
      url = "https://alopexia.com/for-men"
    } else if(which === "women"){
      url = "https://alopexia.com/for-women"
    } else if(which === "team"){
      url = "https://alopexia.com/our-team"
    }
    window.open(url, "_self");
  }

  const isStudyParticipant = localStorage.getItem('study_participant') === 'true';


  const DrawerList = (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      className="sidebarDrawer"
    >
      {/* <List>
                {['Take a Test', 'Products', 'Cart', 'Profile'].map((text, index) => (
                    <ListItem key={text} disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                {index % 2 === 0 ? <HomeIcon /> : <PersonIcon />}
                            </ListItemIcon>
                            <ListItemText primary={text} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List> */}
      <List className="menuItemslist mb-20px">
        {/* <ListItem disablePadding>
          <ListItemButton>
            <ListItemIcon>
              <AccountBoxIcon />
            </ListItemIcon>
            <ListItemText primary="Profile" />
          </ListItemButton>
        </ListItem> */}
        {/* <ListItem disablePadding>
          <ListItemButton>
            <div className="language-listitem">
              <LanguageSelector />
            </div>
          </ListItemButton>
        </ListItem> */}
        {isMobile && (
          <>
            <ListItem disablePadding>
              <ListItemButton onClick={() => handleUrl("home")}>
                {/* <ListItemIcon>
                  <SpeedIcon />
                </ListItemIcon> */}
                <ListItemText primary={i18next.t("Home")} />
              </ListItemButton>
            </ListItem>
            {/* <ListItem disablePadding>
              <ListItemButton onClick={() => handleUrl("about")}>
                <ListItemIcon>
                  <SpeedIcon />
                </ListItemIcon>
                <ListItemText primary={i18next.t("About Alopexia")} />
              </ListItemButton>
            </ListItem> */}
            {/* <ListItem disablePadding>
              <ListItemButton onClick={() => handleUrl("men")}>
                <ListItemText primary={i18next.t("For Men")} />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton onClick={() => handleUrl("women")}>
                <ListItemText primary={i18next.t("For Women")} />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton onClick={() => handleUrl("team")}>
                <ListItemText primary={i18next.t("Our Team")} />
              </ListItemButton>
            </ListItem> */}
            {
              from ?
                '' 
                  :
                <hr className="menuSeprator" />
            }
          </>
        )}
        {
          (!from || (location?.state?.from === 'webheader' && sessionStorage.length > 0)) &&
          <>
            <ListItem disablePadding>
              <ListItemButton onClick={() => navigate("/taketest")}>
                {/* <ListItemIcon>
                  <SpeedIcon />
                </ListItemIcon> */}
                <ListItemText primary={i18next.t("Take a Test")} />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton onClick={() => navigate("/reports")}>
                {/* <ListItemIcon>
                  <SummarizeIcon />
                </ListItemIcon> */}
                <ListItemText primary={i18next.t("Report History")} />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton onClick={() => navigate("/prescriptions")}>
                {/* <ListItemIcon>
                  <img className="prescription_pad" src={imgurl.prescription_pad}/>
                </ListItemIcon> */}
                <ListItemText primary={i18next.t("Prescriptions")} />
              </ListItemButton>
            </ListItem>
            {/* {!isStudyParticipant && <ListItem disablePadding onClick={() => handleFeedback()}>
              <ListItemButton>
                <ListItemText primary={i18next.t("Feedback")} />
              </ListItemButton>
            </ListItem>} */}
            {/* <ListItem disablePadding onClick={() => navigate('/generateqr')}>
              <ListItemButton>
                <ListItemIcon>
                  <AutoDeleteIcon />
                </ListItemIcon>
                <ListItemText primary={i18next.t("Generate QR")} />
              </ListItemButton>
            </ListItem> */}
            <ListItem disablePadding>
              {/* <ListItemButton onClick={() => proceedToNxt()}>
                <ListItemIcon>
                  <FeedbackIcon />
                </ListItemIcon>
                <ListItemText primary={i18next.t("Beta Test Feedback")} />
              </ListItemButton> */}
            </ListItem>
            {/* <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <TimelineIcon />
                </ListItemIcon>
                <ListItemText primary="Track Progress" />
              </ListItemButton>
            </ListItem> */}
            {/* <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <Inventory2Icon />
                </ListItemIcon>
                <ListItemText primary="Products" />
              </ListItemButton>
            </ListItem> */}
            {/* <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <ProductionQuantityLimitsIcon />
                </ListItemIcon>
                <ListItemText primary="Cart" />
              </ListItemButton>
            </ListItem> */}
            {/* <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <DeliveryDiningIcon />
                </ListItemIcon>
                <ListItemText primary="Order History" />
              </ListItemButton>
            </ListItem> */}

              {isStudyParticipant && <ListItem disablePadding>
                <ListItemButton onClick={() => navigate("/alqi-questionnaire")}>
                  <ListItemText primary="Alopecia Life Quality Index" />
                </ListItemButton>
              </ListItem>}

              {<ListItem disablePadding>
                <ListItemButton onClick={() => navigate("/satisfaction-questionnaire")}>
                  <ListItemText primary="Feedback" />
                </ListItemButton>
              </ListItem>}

            <ListItem disablePadding onClick={() => toDo("deleteAccount")}>
              <ListItemButton>
                {/* <ListItemIcon>
                  <AutoDeleteIcon />
                </ListItemIcon> */}
                <ListItemText primary={i18next.t("Delete Account")} />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding onClick={() => toDo("logout")}>
              <ListItemButton>
                {/* <ListItemIcon>
                  <LogoutIcon />
                </ListItemIcon> */}
                <ListItemText primary={i18next.t("Logout")} />
              </ListItemButton>
            </ListItem>
            {/* <hr></hr> */}

            {/* 
            <List className="logoutlistsec">
              {["Logout"].map((text) => (
                <ListItem key={text} disablePadding onClick={()=>logout()}>
                  <ListItemButton>
                    <ListItemIcon>
                      <LogoutIcon />
                    </ListItemIcon>
                    <ListItemText primary={text} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List> */}
            {/* <div className="d-flex justify-content-center align-items-center flex-direction-column qrDiv">
              <img src={imgurl.qrCodeBot} className="w-100 qrCode"></img>
              <p className="w-60">Scan the QR Code to Chat on WhatsApp<WhatsAppIcon/></p>
            </div> */}

          </>
        }
      </List>

      {
        (!from || (from === '/feedback' && sessionStorage.length > 0)) && 
        <Grid container spacing={0} className="userloggedIn">
          <Grid item xs={2} className="userIcongrid">
            {checkUserData?.user_id ? <AccountCircleIcon /> : ""}
          </Grid>
          <Grid item xs={10} className="userInfogrid">
            {/* <Typography>{fname}  {lname}</Typography> */}
            <Typography>
              {localStorage.getItem("phno") && "+" + localStorage.getItem("phno")}
            </Typography>
          </Grid>
        </Grid>
      }

      <hr />

      <Grid container spacing={1} className="mt-5px">
        <Grid item xs={1}></Grid>
        <Grid
          item
          xs={5}
          className="footerCursor"
          onClick={() => handleDrawer("privacy", "open")}
        >
          <Typography className="footerName">
            {i18next.t("Privacy Policy")}
          </Typography>
        </Grid>
        <Grid
          item
          xs={5}
          className="footerCursor"
          onClick={() => handleDrawer("terms", "open")}
        >
          <Typography className="footerName">
            {i18next.t("Terms of Service")}
          </Typography>
        </Grid>
        <Grid item xs={1}></Grid>
      </Grid>

      <Grid container spacing={1} className="mt-5px">
        <Grid item xs={1}></Grid>
        <Grid
          item
          xs={5}
          className="footerCursor"
          onClick={() => handleDrawer("contact", "open")}
        >
          <Typography className="footerName contactinfo">
            {i18next.t("Contact Information")}
          </Typography>
        </Grid>
        {/* <Grid
          item
          xs={5}
          className="footerCursor"
          onClick={() => handleDrawer("refund", "open")}
        >
          <Typography className="footerName">
            {i18next.t("Refund Policy")}
          </Typography>
        </Grid> */}
        <Grid item xs={1}></Grid>
      </Grid>

      <Grid
        container
        spacing={1}
        className="mt-5px mb-10px d-flex justify-content-center align-items-center"
      >
        <Grid item xs={10}>
          <Typography className="footerName">
            {i18next.t("© 2025 Alopexia All Rights Reserved")}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );

  const handleDrawer = (which, to) => {
    // if(which === 'privacy' && to === 'open'){
    //   setPrivacyDrawer(true)
    // } else if(which === 'privacy' && to === 'close'){
    //   setPrivacyDrawer(false)
    // } else if(which === 'terms' && to === 'open'){
    //   setTermsDrawer(true)
    // } else if(which === 'terms' && to === 'close'){
    //   setTermsDrawer(false)
    // }
    let url 
    if(which === "privacy"){
      url = "https://alopexia.com/privacy-policy/"
    } else if(which === "terms"){
      url = "https://alopexia.com/terms-of-service/"
    } else if(which === "contact"){
      url = "https://alopexia.com/contact-information/"
    } else if(which === "refund"){
      url = "https://alopexia.com/policies/refund-policy"
    }
    window.open(url, "_self");
  }

  return (
    <div className="sideBar">
      <Button className="sidebaricon" onClick={toggleDrawer(true)}>
        <DensityMediumIcon />
      </Button>
      <Drawer anchor="right" open={open} onClose={toggleDrawer(false)} className="sidebarImgUpload">
        <div className="closeSidebar" onClick={toggleDrawer(false)}>
          <img src={imgurl.hairlossaiLogo} className="sidebarLogo"/>
          <CloseIcon />
        </div>
        {DrawerList}
      </Drawer>
      <Drawer
        className='privacypolicydrawer'
        anchor={'bottom'}
        open={privacyDrawer}
        onClose={() => handleDrawer('privacy', 'close')}
      >
        <div className='drawerhead'>
          <div className='ellipse cursor-pointer' onClick={() => handleDrawer('privacy', 'close')}>
            <p>X</p>
          </div>
        </div>
        <HtmlContentMaster keyName={'privacypolicy'}/>
      </Drawer>
      <Drawer
        className='termsdrawer'
        anchor={'bottom'}
        open={termsDrawer}
        onClose={() => handleDrawer('terms', 'close')}
      >
        <div className='drawerhead'>
          <div className='ellipse cursor-pointer' onClick={() => handleDrawer('terms', 'close')}>
            <p>X</p>
          </div>
        </div>
        <HtmlContentMaster keyName={'tos'}/>
      </Drawer>
    </div>
  );
}

export default Sidebar;
